import { render, staticRenderFns } from "./post.vue?vue&type=template&id=2839d10f&scoped=true&"
import script from "./post.vue?vue&type=script&lang=js&"
export * from "./post.vue?vue&type=script&lang=js&"
import style0 from "./post.vue?vue&type=style&index=0&id=2839d10f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839d10f",
  null
  
)

export default component.exports